import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
/* eslint-disable no-console */

var defaultHosts = {
  qa: 'https://qa-no-services.theknot.com',
  production: 'https://no-services.theknot.com'
};
var invalidEnv = function invalidEnv(env) {
  console.error("Specified 'env' value: ".concat(_JSON$stringify(env), " is invalid. Please use 'qa' or 'production'"));

  /* Fallback to qa if ENV is invalid */
  return defaultHosts.qa;
};
var configureClient = function configureClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? function () {
      if (process.env.UNION_CONVERSATIONS_ENV) {
        if (process.env.UNION_CONVERSATIONS_ENV !== "qa" && process.env.UNION_CONVERSATIONS_ENV !== "production") {
          throw new Error("Expected UNION_CONVERSATIONS_ENV to be 'qa' or 'production'.");
        }
        console.warn('Using UNION_CONVERSATIONS_ENV could result in a misconfigured environment. It is best that you use UNION_DEPLOYMENT_ENV for all your Union services integrations.');
        return process.env.UNION_CONVERSATIONS_ENV;
      }
      if (process.env.UNION_DEPLOYMENT_ENV) {
        if (process.env.UNION_DEPLOYMENT_ENV !== "qa" && process.env.UNION_DEPLOYMENT_ENV !== "production") {
          throw new Error("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'.");
        }
        return process.env.UNION_DEPLOYMENT_ENV;
      }
      if (true) {
        console.warn("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'. NODE_ENV fallback will be removed in a future version.");
        return process.env.NODE_ENV === 'production' ? 'production' : 'qa';
      }
      throw new Error("Expected UNION_DEPLOYMENT_ENV to be either 'qa' or 'production'.");
    }() : _ref$env,
    _ref$host = _ref.host,
    host = _ref$host === void 0 ? process.env.UNION_CONVERSATIONS_HOST || defaultHosts[env] || invalidEnv(env) : _ref$host;
  return {
    host: host
  };
};
export default configureClient;